'use client';

import type { RumInitConfiguration } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { initialize, resetRumTimingsForNewView } from '@/utils/datadog';

export const DatadogRumInitializer: React.FC<RumInitConfiguration> = (config) => {
    const pathname = usePathname();

    useEffect(() => {
        initialize(config);
    }, [config]);

    useEffect(() => {
        resetRumTimingsForNewView();
    }, [pathname]);

    return null;
};
